import styled, { css } from 'styled-components';
import { boxStyles } from '../Box/styles.js';
import { boxPropExclusions } from '../Box/props.js';

var multiSelect = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__multiSelect",
  componentId: "sc-qcmzx3-0"
})(["position:relative;", " ", " ", ""], function (p) {
  return p.$error && css(["input{border-color:", ";}"], p.theme.multiselect.web.error);
}, function (p) {
  return p.$opened && css(["input{border-color:", ";}"], p.theme.multiselect.web.color);
}, boxStyles);

export { multiSelect };
